module.exports = __webpack_public_path__ + "media/images/crewbloom-4e10f16a23310fa0c8964bf489232d89.png";